export interface FlagLifecycle {
  purpose: 'unclassified' | 'temporary_rollout' | 'experiment' | 'operational_control' | 'permanent_configuration';
  owner: string | null;
  reviewDueDate: string | null;
  intendedOutcome: 'undecided' | 'make_enabled_permanent' | 'remove_feature_path' | 'retain_flag';
  cleanupStage: 'tracking' | 'cleanup_planned' | 'cleanup_deployed';
  workItemUrl: string | null;
  reviewNotes: string | null;
  lastReviewedAt: string | null;
  lastReviewedByUserId: string | null;
}
export type FlagLifecycleInput = Omit<FlagLifecycle, 'lastReviewedAt' | 'lastReviewedByUserId'>;
export interface FlagLifecycleAssessment {
  reasons: string[];
  needsReview: boolean;
  makePermanent: boolean;
  removeFeaturePath: boolean;
  cleanupInProgress: boolean;
  nextAction: string;
}
export const PURPOSE_LABELS = {
  unclassified: 'Unclassified', temporary_rollout: 'Temporary rollout', experiment: 'Experiment',
  operational_control: 'Operational / kill switch', permanent_configuration: 'Permanent configuration',
};
export const OUTCOME_LABELS = {
  undecided: 'Undecided', make_enabled_permanent: 'Make enabled behavior permanent',
  remove_feature_path: 'Remove feature path', retain_flag: 'Retain flag',
};
export const STAGE_LABELS = {
  tracking: 'Tracking', cleanup_planned: 'Cleanup planned', cleanup_deployed: 'Cleanup deployed — admin reported',
};
export const REASON_LABELS: Record<string, string> = {
  needs_classification: 'Needs classification', missing_owner: 'Missing owner', missing_review_date: 'Missing review date',
  review_due_today: 'Review due today', review_overdue: 'Review overdue',
  consider_making_permanent: 'Suggestion: consider making permanent', review_inactive_flag: 'Suggestion: review inactive flag',
  review_default_off_flag: 'Suggestion: review default-off flag', cleanup_planned: 'Cleanup planned',
  verify_deployed_cleanup: 'Verify deployed cleanup',
};
export const LIFECYCLE_VIEWS = [
  { key: 'all', label: 'All flags' }, { key: 'needsReview', label: 'Needs review' },
  { key: 'makePermanent', label: 'Make permanent' }, { key: 'removeFeaturePath', label: 'Remove feature path' },
  { key: 'cleanupInProgress', label: 'Cleanup in progress' },
] as const;
export type LifecycleView = typeof LIFECYCLE_VIEWS[number]['key'];
